import {
  getUsersAsync,
  getUsersDetailAsync,
  deleteUsersAsync,
  updateUserDetailAsync,
} from "./UserReducer";
import { put, takeLatest } from "redux-saga/effects";
import {
  postUsersGetList,
  postUsersUpdate,
  deleteUsersDeleteUser,
  getUsersGetUser,
} from "Api/Api";
import { getType } from "typesafe-actions";
import { call } from "typed-redux-saga";
import { toast } from "react-toastify";
import i18next from "i18next";
import { getResourcePath, Resources } from "Translations/Resources";

function* getUsers(
  action: ReturnType<typeof getUsersAsync.request>,
): Generator {
  try {
    const response = yield* call(postUsersGetList, action.payload);
    if (response.status === 200) {
      yield put(getUsersAsync.success(response.json));
    } else {
      yield put(getUsersAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(getUsersAsync.failure(err));
  }
}
export function* getUsersSaga() {
  yield takeLatest(getType(getUsersAsync.request), getUsers);
}

function* getUserDetail(
  action: ReturnType<typeof getUsersDetailAsync.request>,
): Generator {
  try {
    const response = yield* call(getUsersGetUser, action.payload);
    if (response.status === 200) {
      yield put(getUsersDetailAsync.success(response.json));
    } else {
      yield put(getUsersDetailAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(getUsersDetailAsync.failure(err));
  }
}
export function* getUserDetailSaga() {
  yield takeLatest(getType(getUsersDetailAsync.request), getUserDetail);
}

function* deleteUser(
  action: ReturnType<typeof deleteUsersAsync.request>,
): Generator {
  try {
    const response = yield* call(deleteUsersDeleteUser, action.payload);
    if (response.status === 200) {
      const data = JSON.parse(response.json) as boolean;
      data
        ? toast.success(
            i18next.t(getResourcePath(Resources.Users.List.Delete.Success)),
          )
        : toast.error(
            i18next.t(getResourcePath(Resources.Users.List.Delete.Fail)),
          );
      yield put(deleteUsersAsync.success(response.json));
    } else {
      toast.error(i18next.t(getResourcePath(Resources.Users.List.Delete.Fail)));
      yield put(deleteUsersAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(deleteUsersAsync.failure(err));
  }
}
export function* deleteUserSaga() {
  yield takeLatest(getType(deleteUsersAsync.request), deleteUser);
}

function* updateUserDetail(
  action: ReturnType<typeof updateUserDetailAsync.request>,
): Generator {
  try {
    const response = yield* call(postUsersUpdate, action.payload);
    if (response.status === 200) {
      if (response.json.isValid) {
        toast.success(
          i18next.t(getResourcePath(Resources.Users.Detail.SaveSuccess)),
        );
      } else {
        toast.error(
          i18next.t(
            response.json.validationErrors
              ? response.json.validationErrors[0].message
              : getResourcePath(Resources.Users.Detail.SaveFail),
          ),
        );
      }
      yield put(
        updateUserDetailAsync.success({
          user: action.payload,
          result: response.json,
        }),
      );
    } else {
      toast.error(i18next.t(getResourcePath(Resources.Users.Detail.SaveFail)));
      yield put(updateUserDetailAsync.failure(new Error()));
    }
  } catch (err) {
    yield put(updateUserDetailAsync.failure(err));
  }
}
export function* updateUserDetailSaga() {
  yield takeLatest(getType(updateUserDetailAsync.request), updateUserDetail);
}
